import { Component, OnInit, Input, Output, ElementRef, EventEmitter, HostBinding } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { ButtonMenuModel } from '../../models/button-menu/button-menu.model';
import { ButtonMenuStylingModel } from '../../models/button-menu/button-menu-styling.model';
import { ButtonMenuTemplates } from '../../templates/button-menu.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Button-Menu Component</p>
 * <pre>
 * <code>
 * import {{'{'}} ButtonMenuModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} ButtonMenuStylingModel {{'}'}} from 'cedrus-fusion'
 * <</code>cf-button-menu<code>></code><code><</code><code>/</code>cf-button-menu<code>>
 * </code>
 * </pre>
 */
export class CfButtonMenuComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden 
 * <p> The type of the needed button.</p>
 * <p> Type can be: mat-button, mat-raised-button.</p>
 */
buttonType: string;
/**
 * <pre>{{'{'}}
 *  display: boolean, // Default: True
 *  disable: boolean, // Default: False
 *  buttonProperty: ButtonModel,
 *  menuProperty: MenuModel
 * {{'}'}}
 * </pre>
 */
public properties: ButtonMenuModel;
/**
 * <pre>{{'{'}}
 * // styling of the container surrounding the button-menu
 * container: {{'{'}}
 *   dynamic class: function() -> string, //function that returns a string of the name of the class
 *   class: string //name of the class specified in you scss/css file
 * {{'}'}},
 * buttonStyling: {{'{'}} buttonStylingModel {{'}'}}, // Refer to button component
 * menuStyling: {{'{'}} MenuStylingModel {{'}'}}, // Refer to menu component
 * {{'}'}}
 * </pre>
 */
public styling: ButtonMenuStylingModel;
/**
 * <p>Event emitted when the button is clicked (left part of button).</p>
 */
onClick = new EventEmitter();
/**
 * @hidden
 */
notificationAction: any;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new ButtonMenuModel();
    this.styling = new ButtonMenuStylingModel();
  }
/**
 * @hidden 
 * <p>On initialization:</p>
 * <p>Check to see if any of the angular material button types are needed to be passed to the child button.</p>
 * <p>Types are: <b>md-button</b>, <b>md-raised-button</b>.</p>
 * <p>Then initialize the button element.</p>
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
    this.getMyTemplate('button-menu', ButtonMenuTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'BUTTON-MENU').then( sampler => {
        let /** @type {?} */ active = new ButtonMenuStylingModel(this.activeTemplate.style);
        this.styling = Object.assign(active, this.styling);
        // console.log('BUTTON-MENU', this);
      });
    });
  }
/**
 * @hidden 
 * <p>The method will emit event when the button is clicked</p>
 * @return {?}
 */
buttonClicked() { this.onClick.emit(); }
/**
 * @hidden 
 * It is function for creating Notification click events by using Core Component <b>notificationAction</b> event emmiter.
 * @param {?} notification 	it is json notification object
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-button-menu',
  template: "<span *ngIf=\"_inited && properties?.display\" [class]=\"styling?.container?.class\" [ngClass]=\"getDynamicClasses(styling?.container?.dynamicClass)\"> <cf-button [properties]=\"properties?.buttonProperty\" [styling]=\"styling?.buttonStyling\"></cf-button> <cf-button label=\"\" [iconProperty]=\"null\" type=\"{{properties?.buttonProperty?.type}}\" class=\"cf-button-menu-trigger\" [styling]=\"styling?.buttonStyling\" (onClick)=\"menu?.openMenu()\"> <cf-menu #menu [properties]=\"properties?.menuProperty\" [styling]=\"styling?.menuStyling\"></cf-menu> </cf-button> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </span>",
  styles: [":host { position: relative; z-index: 0; } :host > span { display: flex; flex-direction: row; } :host > span cf-button:nth-child(1) ::ng-deep button { border-radius: 4px 0 0 4px; } :host > span cf-button:nth-child(2) ::ng-deep button { position: relative; z-index: 0; line-height: initial; padding: 0px; width: 40px; min-width: 40px; min-height: 36px; border-radius: 0 4px 4px 0; } :host > span cf-button:nth-child(2) ::ng-deep button:before { content: ''; display: block; width: 100%; height: 100%; position: absolute; z-index: 1; } :host.notification-clickable cf-notification:hover { cursor: pointer; } :host ::ng-deep .cf-icon { color: inherit; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'onClick': [{ type: Output },],
};
}

function CfButtonMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfButtonMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfButtonMenuComponent.ctorParameters;
/** @type {?} */
CfButtonMenuComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfButtonMenuComponent.prototype.notificationClickable;
/**
 * @hidden 
 * <p> The type of the needed button.</p>
 * <p> Type can be: mat-button, mat-raised-button.</p>
 * @type {?}
 */
CfButtonMenuComponent.prototype.buttonType;
/**
 * <pre>{{'{'}}
 *  display: boolean, // Default: True
 *  disable: boolean, // Default: False
 *  buttonProperty: ButtonModel,
 *  menuProperty: MenuModel
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfButtonMenuComponent.prototype.properties;
/**
 * <pre>{{'{'}}
 * // styling of the container surrounding the button-menu
 * container: {{'{'}}
 *   dynamic class: function() -> string, //function that returns a string of the name of the class
 *   class: string //name of the class specified in you scss/css file
 * {{'}'}},
 * buttonStyling: {{'{'}} buttonStylingModel {{'}'}}, // Refer to button component
 * menuStyling: {{'{'}} MenuStylingModel {{'}'}}, // Refer to menu component
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfButtonMenuComponent.prototype.styling;
/**
 * <p>Event emitted when the button is clicked (left part of button).</p>
 * @type {?}
 */
CfButtonMenuComponent.prototype.onClick;
/**
 * @hidden
 * @type {?}
 */
CfButtonMenuComponent.prototype.notificationAction;
/**
 * @hidden
 * @type {?}
 */
CfButtonMenuComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
